import { Buffer } from 'buffer'

export const encode64 = b => Buffer.from(b).toString('base64')
export const decode64 = s => Buffer.from(s, 'base64')
